import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Avatar,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import { useTranslation } from "react-i18next";

import {
  accordionStyles,
  accordionSummaryStyles,
  iconStyles,
  avatarStyles,
  accordionDetailsStyles,
  labelStyles,
  valueStyles,
  detailRowStyles,
  actionContainerStyles,
  summaryBoxStyles,
} from "./styles";

const CustomAccordion = ({
  summaryContent,
  summaryActions,
  details = [],
  actions,
  imageUrl,
  imageContent,
  imgUrlAlt,
  expanded,
  onChange,
}) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation("page-my-jobs", { keyPrefix: "table_data" });
  const isHebrew = i18n.language === "he";

  const rotatedIconStyles = {
    ...iconStyles,
    ".Mui-expanded &": {
      transform: isHebrew ? "rotate(-90deg)" : "rotate(90deg)",
    },
  };

  return (
    <Accordion expanded={expanded} onChange={onChange} sx={accordionStyles}>
      <AccordionSummary expandIcon={null} sx={accordionSummaryStyles}>
        {isHebrew ? (
          <KeyboardArrowLeftOutlinedIcon sx={rotatedIconStyles} />
        ) : (
          <KeyboardArrowRightIcon sx={rotatedIconStyles} />
        )}
        <Box sx={summaryBoxStyles}>
          <Box display="flex" alignItems="center">
            {imageContent ? (
              imageContent
            ) : (
              <Avatar alt={imgUrlAlt} src={imageUrl} sx={avatarStyles} />
            )}
            <Box ml="16px">{summaryContent}</Box>
          </Box>
          {summaryActions}
        </Box>
      </AccordionSummary>

      <AccordionDetails sx={accordionDetailsStyles}>
        {details.map((item, index) => (
          <Box key={index} sx={detailRowStyles}>
            <Typography sx={labelStyles}>{item.label}</Typography>
            <Typography sx={valueStyles}>{item.value}</Typography>
          </Box>
        ))}

        {actions && (
          <Box sx={actionContainerStyles}>
            <Typography sx={labelStyles}>{t("actions")}</Typography>
            {actions}
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default CustomAccordion;
